module.exports = window.__MEEGO_EXTERNALS_PROMISE__['@meego-progressive/formula/common'];